import * as React from 'react'
import cx from 'classnames'
import { Formik, Form, Field, FieldProps } from 'formik'

import { DocHandbookItem } from 'types'

import Styles from '../HandbookItems.module.scss'
import { useBlurOnNavigateRef } from './hooks'
import { Icon } from './Components/Icon'
import { useUpdateAlmanacFile } from 'hooks/queries/almanacFiles/useUpdateAlmanacFile'
import { HandbookTreeItem } from 'components/Handbook2_0/Stores/HandbookTreeItem'

interface Props {
  item: DocHandbookItem
  onCancel?: () => void
  onRename?: () => void
  treeItem: HandbookTreeItem
}

export default function DocTitleInput({ item, onCancel, onRename, treeItem }: Props) {
  const inputEl = useBlurOnNavigateRef<HTMLInputElement>()
  const { document: doc, title } = item
  const { mutateAsync } = useUpdateAlmanacFile({ key: doc.key })

  if (!doc) return null

  return (
    <Formik<{ title: string }>
      onSubmit={async (values) => {
        treeItem.updateAttrs({ title: values.title })
        try {
          await mutateAsync({ ...values })
          onRename?.()
        } catch {
          treeItem.updateAttrs({ title: title })
        }
      }}
      initialValues={{ title: title }}
      validate={(values) => {
        const errors = {} as { title?: boolean }
        if (!values.title) {
          errors.title = true
        }
        return errors
      }}
    >
      {({ isValid, submitForm }) => (
        <Form>
          <div className={cx(Styles.inputWrapper, { [Styles.error]: !isValid })}>
            <Icon item={item} />
            <Field name="title">
              {({ field }: FieldProps) => (
                <input
                  ref={inputEl}
                  {...field}
                  autoFocus
                  placeholder="Document name"
                  onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Escape') {
                      onCancel?.()
                    }
                  }}
                  onBlur={(e) => {
                    field.onBlur(e)
                    if (field.value && isValid) {
                      return submitForm()
                    }
                    onCancel?.()
                  }}
                />
              )}
            </Field>
          </div>
        </Form>
      )}
    </Formik>
  )
}
